import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  CREATE_OPTOMETRIA_NEONATOS_REQUEST,
  CREATE_OPTOMETRIA_NEONATOS_SUCCESS,
  CREATE_OPTOMETRIA_NEONATOS_FAILURE,
  FETCH_OPTOMETRIA_NEONATOS_REQUEST,
  FETCH_OPTOMETRIA_NEONATOS_SUCCESS,
  FETCH_OPTOMETRIA_NEONATOS_FAILURE,
  SET_OPTOMETRIA_NEONATOS_PAGE,
  SET_OPTOMETRIA_NEONATOS_LIMIT
} from '../../../../constants/consultas/optometria_neonatos/Optometria_neonatos';
import { message } from 'antd';
import { RootState } from '../../../store/store';
import fetchWithIP from '../../utils/FechHeaders';

export const createOptometriaNeonatosRequest = () => ({
  type: CREATE_OPTOMETRIA_NEONATOS_REQUEST
});

export const createOptometriaNeonatosSuccess = (data: any) => ({
  type: CREATE_OPTOMETRIA_NEONATOS_SUCCESS,
  payload: data
});

export const createOptometriaNeonatosFailure = (error: string) => ({
  type: CREATE_OPTOMETRIA_NEONATOS_FAILURE,
  payload: error
});

export const fetchOptometriaNeonatosRequest = () => ({
  type: FETCH_OPTOMETRIA_NEONATOS_REQUEST
});

export const fetchOptometriaNeonatosSuccess = (data: any) => ({
  type: FETCH_OPTOMETRIA_NEONATOS_SUCCESS,
  payload: data
});

export const fetchOptometriaNeonatosFailure = (error: string) => ({
  type: FETCH_OPTOMETRIA_NEONATOS_FAILURE,
  payload: error
});

export const setOptometriaNeonatosPage = (page: number) => ({
  type: SET_OPTOMETRIA_NEONATOS_PAGE,
  payload: page
});

export const setOptometriaNeonatosLimit = (limit: number) => ({
  type: SET_OPTOMETRIA_NEONATOS_LIMIT,
  payload: limit
});

export const createOptometriaNeonatos = (
  optometriaData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(createOptometriaNeonatosRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        'optometria-neonatos',
        {
          method: 'POST',
        },
        optometriaData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al crear la consulta de optometría neonatal');
      }

      dispatch(createOptometriaNeonatosSuccess(data));
      message.success('Consulta de optometría neonatal guardada exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al crear la consulta de optometría neonatal';
      dispatch(createOptometriaNeonatosFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchOptometriaNeonatos = (
  page: number = 1,
  limit: number = 10,
  search?: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchOptometriaNeonatosRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let endpoint = `optometria-neonatos?page=${page}&limit=${limit}`;
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }

      const response = await fetchWithIP(endpoint, { method: 'GET' });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las consultas de optometría neonatal');
      }

      dispatch(fetchOptometriaNeonatosSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener las consultas de optometría neonatal';
      dispatch(fetchOptometriaNeonatosFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};